/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
        "aws_project_region": "us-east-1",
        "aws_cognito_identity_pool_id": "us-east-1:19881e33-abb4-480d-8953-33cefb86cbf2",
        "aws_cognito_region": "us-east-1",
        "aws_user_pools_id": "us-east-1_9GBcrBHu7",
        "aws_user_pools_web_client_id": "3mreonjke9fl0hf29s4erp9oeg",
        "oauth": {}
    };
    
    
    export default awsmobile;
    
    
